import type ApiFactory from '~library/services/api-factory'
import AssignBenefitsApi from './assign-benefits-api'
import BenefitAndVoucherManagementApi from './benefit-and-voucher-management-api'
import CommonUnAuthApi from './common-un-auth-api'
import CompanyEmployeeApi from './company-employee-api'
import CompanyEmployeeBindApi from './company-employee-bind-api'
import CorporateAccountApi from './corporate-account-api'
import CorporateApi from './corporate-api'
import JoinUsApi from './join-us-api'
import LoginApi from './login-api'
import LoginAuthApi from './login-auth-api'
import MailPreviewApi from './mail-preview-api'
import ManagerBenefitApi from './manager-benefit-api'
import MyAccountApi from './my-account-api'
import NewsApi from './news-api'
import TravelAmountStatisticsApi from './travel-amount-statistics-api'
import TravelAssistantApi from './travel-assistant-api'

/**
 * API - 不需登入
 */
export const initUnAuthApi = (api: ApiFactory) => ({
  commonUnAuth: new CommonUnAuthApi(api),
  login: new LoginApi(api),
  joinUs: new JoinUsApi(api)
})

/**
 * API - API 會員綁定
 */
export const initBindApi = (api: ApiFactory) => ({
  companyEmployeeBind: new CompanyEmployeeBindApi(api)
})

/**
 * API - 需登入
 */
export const initAuthApi = (api: ApiFactory) => ({
  assignBenefits: new AssignBenefitsApi(api),
  corporate: new CorporateApi(api),
  loginAuth: new LoginAuthApi(api),
  companyEmployee: new CompanyEmployeeApi(api),
  corporateAccount: new CorporateAccountApi(api),
  managerBenefit: new ManagerBenefitApi(api),
  myAccount: new MyAccountApi(api),
  news: new NewsApi(api),
  travelAmountStatistics: new TravelAmountStatisticsApi(api),
  travelAssistant: new TravelAssistantApi(api),
  benefitAndVoucherManagement: new BenefitAndVoucherManagementApi(api),
  mailPreview: new MailPreviewApi(api)
})
